import React, { useState, useEffect, useRef } from "react";
import { Translate } from "../language";
import EmojiPicker from "emoji-picker-react";
import { ReactComponent as CloseIcon } from "../img/ic_cerrar.svg";
import { ReactComponent as BackIcon } from "../img/flecha-hacia-atras.svg";
import emojiImg from "../assets/img/smile.png";
import audioImg from "../img/ic_audio.png";
import { connect } from "react-redux";
import { fileUpload, createPost, createZonePost } from "../actions/fileUploadActions";
import ModalTagFriend from "./ModalTagFriend";
import ModalGif from "./ModalGif";
import play from "../img/ic_play.png";
import ModalAudioPost from "./ModalAudioPost";
import GifPlayer from "react-gif-player";
import { UseComponentVisible } from "../containers/UseComponentVisible";
import ModalMenu from "./ModalMenu";
import { editPost } from "../actions/userActions";
import ModalSelectPrivacy from "./ModalSelectPrivacy";
import ButtonIcon from "../utils/components/ButtonIcon/ButtonIcon";
import {
  AudioIcon,
  GifIcon,
  PictureIcon,
  VideoIcon,
} from "../assets/icons";
import Button from "../utils/components/Button/Button";
import InputTextArea from "../utils/components/InputTextArea/InputTextArea";

const ModalNewPost = ({
  postData,
  displayModal,
  isProfessionalUser,
  editPost,
  idAlbum,
  nameAlbum,
  closeModal,
  history,
  view,
  createPost,
  createZonePost,
  zone,
  isLoadingNewPost,
  _idEc
}) => {
  const [description, setDescription] = useState("");
  const [isEditPost, setIsEditPost] = useState(false);
  const [idEditPost, setIdEditPost] = useState(null);
  const [isShowEmojiPicker, setIsShowEmojiPicker] = useState(false);
  const [isShowTagFriend, setIsShowTagFriend] = useState(false);

  const [isShowAudio, setIsShowAudio] = useState(false);
  const [ubication, setUbication] = useState("");
  const [isShowSelectPrivacy, setIsShowSelectPrivacy] = useState(false);
  const [privacy, setPrivacy] = useState(0);
  const [isShowGif, setIsShowGif] = useState(false);
  const [isOnlyGif, setIsOnlyGif] = useState(false);
  const [isOnlyAudio, setIsOnlyAudio] = useState(false);
  const [isOnlyMultimedia, setIsOnlyMultimedia] = useState(false);
  const [dataFiles, setDataFiles] = useState({});
  const [isLoagindData, setIsLoagindData] = useState(false);
  const [isShowEditPost, setIsShowEditPost] = useState(false);
  const [friendsTag, setFriendsTag] = useState({});
  const imgSelector = useRef();

  useEffect(() => {
    if (!displayModal) {
      setIsShowTagFriend(false);
      setIsShowAudio(false);
      setIsShowGif(false);
      setIsShowSelectPrivacy(false);
    }
    return () => { };
  }, [displayModal]);
  useEffect(() => {
    if (postData) {
      console.log();
      setIsEditPost(true);
      //setIsOnlyMultimedia(true);
      //setIsOnlyGif(true);
      setIdEditPost(postData._id);
      setDescription(postData.description);
      //setUbication(postData.ubication);
      setFriendsTag({});
      postData.taggedUsers && postData.taggedUsers.map((tagFriend) => {
        setFriendsTag((prevState) => {
          return { ...prevState, [tagFriend._id]: tagFriend };
        });
      });
    }
  }, [postData]);
  /* console.log(); */
  const selectTagFriend = (e) => {
    e.stopPropagation();
    setIsShowGif(false);
    setIsShowAudio(false);
    setIsShowSelectPrivacy(false);
    setIsShowTagFriend(!isShowTagFriend);
  };

  const selectAudio = (e) => {
    if (e) e.stopPropagation();

    setIsShowGif(false);
    setIsShowTagFriend(false);
    setIsShowSelectPrivacy(false);
    setIsShowAudio(!isShowAudio);
  };

  const selectGif = (e) => {
    e.stopPropagation();
    setIsShowTagFriend(false);
    setIsShowAudio(false);
    setIsShowSelectPrivacy(false);
    setIsShowGif(!isShowGif);
  };

  const selectPrivacy = (e) => {
    e.stopPropagation();
    setIsShowTagFriend(false);
    setIsShowAudio(false);
    setIsShowGif(false);
    setIsShowSelectPrivacy(!isShowSelectPrivacy);
  };

  const divStyle = {
    display: displayModal ? "block" : "none",
  };

  const close = (e) => {
    if (e) { e.persist(); e.stopPropagation(); }
    console.log();
    setIsShowTagFriend(false);
    setIsShowAudio(false);
    setIsShowGif(false);
    setIsShowSelectPrivacy(false);
    closeModal(e);
  };

  const { ref, isComponentVisible, setIsComponentVisible } =
    UseComponentVisible(false);

  const auto_height = (e) => {
    e.target.style.height = "1px";
    e.target.style.height = e.target.scrollHeight + "px";
  };

  const myCallback = (event, code) => {
    console.log();
    setDescription(description + code.emoji);
  };

  const onFileChange = (event) => {

    var filesTarget = event.target.files;
    var img = {};
    var video = {};
    setIsOnlyMultimedia(true);
    for (let i = 0; i < filesTarget.length; i++) {
      if (filesTarget[i].type.includes("image")) {
        img[i] = new Image();
        img[i].onload = () => {
          filesTarget[i].url = URL.createObjectURL(filesTarget[i]);
          setDataFiles((prevState) => {
            return {
              
              [filesTarget[i].url]: {
                type: filesTarget[i].type,
                taggedUsers: [],
                height: img[i].naturalHeight,
                width: img[i].naturalWidth,
                url: filesTarget[i].url,
                file: filesTarget[i],
              },
            };
          });
        };
        img[i].src = URL.createObjectURL(filesTarget[i]);
      }
      if (filesTarget[i].type.includes("video")) {
        video[i] = document.createElement("video");
        video[i].onloadeddata = () => {
          filesTarget[i].url = URL.createObjectURL(filesTarget[i]);

          setDataFiles((prevState) => {
            return {
          
              [filesTarget[i].url]: {
                type: filesTarget[i].type,
                taggedUsers: [],
                height: video[i].videoHeight,
                width: video[i].videoWidth,
                url: filesTarget[i].url,
                file: filesTarget[i],
              },
            };
          });
        };
        video[i].src = URL.createObjectURL(filesTarget[i]);
      }
      if (filesTarget[i].type.includes("audio")) {
        filesTarget[i].url = URL.createObjectURL(filesTarget[i]);

        setDataFiles((prevState) => {
          return {
       
            [filesTarget[i].url]: {
              type: filesTarget[i].type,
              taggedUsers: [],
              url: filesTarget[i].url,
              file: filesTarget[i],
            },
          };
        });
      }
    }
  };

  const deleteFile = (idFile) => {
    setDataFiles((prevState) => {
      delete prevState[idFile];
      return { ...prevState };
    });
    console.log();
    if (Object.values(dataFiles).length === 2) setIsShowEditPost(false);
  };
  const deleteAllImgs = () => {
    imgSelector.current.value = "";
    setIsOnlyGif(false);
    setIsOnlyMultimedia(false);
    setIsOnlyAudio(false);
    setDataFiles({});
  };
  const clear = () => {
    deleteAllImgs();
    setDescription("")
    setFriendsTag({})
    setPrivacy(0)
    setDataFiles({});
    
  }

  const onFileUpload = (e) => {
    e.persist()
    var tagFriends = Object.keys(friendsTag);
    var newPostObj = {}
    if (isEditPost) {
      var newPostObj = {
        postId: postData._id,
        description: description,
        tagFriends: tagFriends
      };
    }

    const formData = new FormData();
    const numFile = Object.values(dataFiles).length

    formData.append("description", description);
    formData.append("privacy", privacy);
    tagFriends.map(tagFriend => {
      formData.append("taggedUsers", tagFriend)
    })
    if (tagFriends.length > 0) {
      
    }
    let whitGifs = false;
    if (numFile ===0) {
      formData.append("typePost", "0");
    } else if (numFile ===1) {
      if (idAlbum) {
        formData.append("typePost", "1");
        formData.append("albumId", idAlbum);
        formData.append("isSaved", true);
      } else {
        formData.append("typePost", "2");
        //formData.append('defaultAlbum', 0)
      }

      Object.values(dataFiles).map((dataFile, i) => {
        formData.append('file', dataFile.file);
      });

      // formData.append('albumId',idAlbum)
    }
    if (!whitGifs) {
      if (isEditPost) {
        editPost(newPostObj, () => {
          setDescription("")
          setFriendsTag({})
          setPrivacy(0)
          
          close(e) } );
      } else {

        if (zone) {
          formData.append("zoneId", zone._id)
          createZonePost(formData, () => { clear(); close(e); })
        } else {
          createPost(formData, history, () => { clear(); close(e); }, _idEc)
        }
      }
      //setIsLoagindData(true);
    }
  };

  const setDescriptionData = (value, file) => {
    setDataFiles((prevState) => {
      return {
        ...prevState,
        [file.url]: {
          description: value,
          height: file.height,
          width: file.width,
          name: file.name,
          url: file.url,
          file: file.file,
        },
      };
    });
    console.log();
  };

  const showEditPanels = (data) => {
    var viewData = <div></div>;
    if (data.file.type.includes("gif"))
      viewData = <GifPlayer gif={data.url} autoPlay={false} />;
    if (data.file.type.includes("image") && !data.file.type.includes("gif"))
      viewData = <img alt="img" className="img-post-view" src={data.url} />;
    if (data.file.type.includes("video"))
      viewData = (
        <video preload="auto" className="video-post-view" controls>
          <source src={data.url}></source>
        </video>
      );
    if (data.file.type.includes("audio"))
      viewData = (
        <div className="parent-width">
          <audio preload="auto" controlsList="nodownload" controls>
            <source src={data.url}></source>
          </audio>
        </div>
      );
    return (
      <div className="wrapper-2 relative mb-3">
        <div onClick={() => deleteFile(data.url)} className="close-modal-post">
          <CloseIcon className="cls-1" height="13" width="13" />
        </div>
        <div className="card-post-view">{viewData}</div>
        <div className="p-1">
          <textarea
            className="textarea-new-post"
            rows="4"
            value={data.description}
            onChange={(e) => setDescriptionData(e.target.value, data)}
            onInput={(e) => auto_height(e)}
            name="comment"
            type="text"
            placeholder="Pie de foto"
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      {isLoadingNewPost ? (
        isEditPost ? (
          <div
            onClick={(e) => e.stopPropagation()}
            className="new-post-loaging-files"
          >
            {"  Editando..."}
          </div>
        ) : (
          <div
            onClick={(e) => e.stopPropagation()}
            className="new-post-loaging-files"
          >
            Publicando...
          </div>
        )
      ) : (
        <div></div>
      )}

      <div
        className={view === "Profile" ? "modal modal-profile" : "modal"}
        onClick={close}
        style={divStyle}
      >
        <div
          className="modal-content modal-content-new-post"
          onClick={(e) => e.stopPropagation()}
        >
          <div onClick={close} className="close-modal">
            <CloseIcon className="cls-1 pointer" height="18" width="18" />
          </div>

          <div>
            <div className="text-modal-new-post ">
              {nameAlbum || zone
                ? `${Translate("uploadConentTo", "es")}  ${nameAlbum ? nameAlbum : " "
                }  ${zone ? zone.name : ""}`
                : Translate("tittleModalNewPost", "es")}
            </div>
            <div className="content-modal-new-post">

              <div style={{ maxHeight: "30vh" }} className="scroll-menu mt-1">
                <div className="cardScroll">
                  <InputTextArea
                    name="comment"
                    type="text"
                    placeholder={Translate("writes", "es")}
                    value={description}
                    setValue={(v) => {
                      setDescription(v);
                    }}
                  />
                </div>

                {Object.values(dataFiles).length > 0 && (
                  <div>
                    {!isShowEditPost ? (
                      <div>
                        <div className="new-post-contanier-all-multimedia">
                          {Object.values(dataFiles).length < 5 ? (
                            <div className="new-post-contanier-img">
                              {Object.values(dataFiles).map(
                                (dataFile, index) => {
                                  var lengthFiles =
                                    Object.values(dataFiles).length;
                                  var classeNameData =
                                    "new-post-img-preview-" +
                                    lengthFiles +
                                    "-" +
                                    index;

                                  if (dataFile.file.type.includes("image"))
                                    return (
                                      <img
                                        alt="img"
                                        key={index}
                                        className={classeNameData}
                                        src={dataFile.url}
                                      ></img>
                                    );
                                  if (dataFile.file.type.includes("audio"))
                                    return (
                                      <div className="commet-audio-add-container">
                                        <audio
                                          controlsList="nodownload"
                                          controls
                                        >
                                          <source src={dataFile.url}></source>
                                        </audio>
                                      </div>
                                    );
                                  if (dataFile.file.type.includes("video"))
                                    return (
                                      <div
                                        key={index}
                                        className={classeNameData}
                                      >
                                        <div className="new-post-video-file">
                                          <video className={classeNameData}>
                                            <source src={dataFile.url}></source>
                                            <div className="new-post-amount-imgs">
                                              +{lengthFiles - 5}
                                            </div>
                                          </video>
                                          <img
                                            alt="img"
                                            key={index}
                                            className="new-post-video-play"
                                            src={play}
                                          ></img>
                                        </div>
                                      </div>
                                    );
                                }
                              )}
                            </div>
                          ) : (
                            <div className="new-post-contanier-img-5">
                              {Object.values(dataFiles).map(
                                (dataFile, index) => {
                                  var lengthFiles =
                                    Object.values(dataFiles).length;
                                  var classeNameData1 =
                                    "new-post-img-preview-5-1";
                                  var classeNameData2 =
                                    "new-post-img-preview-5-2";
                                  if (index < 2) {
                                    if (dataFile.file.type.includes("image"))
                                      return (
                                        <img
                                          alt="img"
                                          key={index}
                                          className={classeNameData1}
                                          src={dataFile.url}
                                        ></img>
                                      );

                                    if (dataFile.file.type.includes("audio"))
                                      return (
                                        <div className={classeNameData1}>
                                          <img
                                            alt="img"
                                            key={index}
                                            className="audio-new-post"
                                            src={audioImg}
                                          ></img>
                                        </div>
                                      );
                                    if (dataFile.file.type.includes("video"))
                                      return (
                                        <div
                                          key={index}
                                          className={classeNameData1}
                                        >
                                          <div className="new-post-video-file">
                                            <video className={classeNameData1}>
                                              <source
                                                src={dataFile.url}
                                              ></source>
                                              <div className="new-post-amount-imgs">
                                                +{lengthFiles - 5}
                                              </div>
                                            </video>
                                            <img
                                              alt="img"
                                              key={index}
                                              className="new-post-video-play"
                                              src={play}
                                            ></img>
                                          </div>
                                        </div>
                                      );
                                  }
                                
                                  
                                }
                              )}
                            </div>
                          )}
                          {!isEditPost && (
                            <div
                              onClick={() => deleteAllImgs()}
                              className="close-modal-post"
                            >
                              <CloseIcon
                            
                                height="15"
                                width="18"
                              />
                            </div>
                          )}
                          {Object.values(dataFiles).length > 1 && (
                            <div
                              onClick={() => setIsShowEditPost(true)}
                              className="new-post-option-imgs"
                            >
                              {Translate("edit", "es")}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="relative">
                        {Object.values(dataFiles).map((data) =>
                          showEditPanels(data)
                        )}
                        <div
                          onClick={() => setIsShowEditPost(false)}
                          className="new-post-delete-all-post close-modal-post"
                        >
                          <BackIcon
                      
                            height="15"
                            width="18"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div
                onClick={(e) => e.stopPropagation()}
                name="emoji-icon"
                className="emoji-icon mt-1"
              >
                <ModalMenu
                  contentButton={
                    <img
                      src={emojiImg}
                      className="pointer"
                      style={{ width: "25px", height: "25px" }}
                      alt="img"
                    />
                  }
                  contentModal={
                    <div
                      name="picker-emoji-new-post"
                      className="emoji-picker-dowm"
                    >
                      <EmojiPicker onEmojiClick={myCallback} />
                    </div>
                  }
                />
              </div>
            </div>
            {!isEditPost && (
              <div className="funtion-new-post">
                <div className="upload-data-new-post">

                  {/* <ButtonIcon
                  Icon={CoralOnlyIcon}
                  onClick={(e) => {
                    startStream(e);
                  }}
                  text={Translate("createLive", "es")}
                /> */}
                  <ButtonIcon
                    Icon={AudioIcon}
                    onClick={(e) => {
                      if (!isOnlyGif && !isOnlyMultimedia) selectAudio(e);
                    }}
                    text={Translate("audio", "es")}
                  />
                  <ButtonIcon
                    Icon={VideoIcon}
                    onClick={() => {
                      setIsShowTagFriend(false);
                      setIsShowAudio(false);
                      setIsShowGif(false);
                      imgSelector.current.accept = "video/*";
                      imgSelector.current.click();
                      setIsShowSelectPrivacy(false);
                    }}
                    text={Translate("video", "es")}
                  />

                  <input
                    type="file"
                    ref={imgSelector}
                    onChange={(event) => {
                      onFileChange(event);
                    }}
                    multiple
                    accept=".png,.jpg,.jpeg,.gif,video/*,audio/*"
                  />
                  <ButtonIcon
                    Icon={PictureIcon}
                    onClick={() => {
                      setIsShowTagFriend(false);
                      setIsShowAudio(false);
                      setIsShowGif(false);
                      imgSelector.current.accept = "image/*";
                      imgSelector.current.click();
                      setIsShowSelectPrivacy(false);
                    }}
                    text={Translate("image", "es")}
                  />
                  <ButtonIcon
                    Icon={GifIcon}
                    onClick={(e) => {
                      selectGif(e);
                    }}
                    text={Translate("gif", "es")}
                  />
                  <div style={{ flexGrow: 0 }}>
                    <ModalAudioPost
                      setOnlyAudio={setIsOnlyAudio}
                      setData={setDataFiles}
                      displayModal={isShowAudio}
                      closeModal={selectAudio}
                    />
                    <ModalGif
                      setOnlygif={setIsOnlyGif}
                      setData={setDataFiles}
                      displayModal={isShowGif}
                      closeModal={selectGif}
                    />
                  </div>
                </div>

              </div>
            )}
            <div className="footer-add-post">
              <div className="privacity-new-post">
                <div
                  onClick={selectPrivacy}
                  className="text-tag-friend-new-post column pointer centerItems ml-2"
                >
                  <div className="circle-black"></div>
                  <div>{Translate("privacity", "es")}</div>
                </div>
              </div>
              <ModalSelectPrivacy
                privacy={privacy}
                setPrivacy={setPrivacy}
                displayModal={isShowSelectPrivacy}
                closeModal={selectPrivacy}
              />
              <div
                onClick={selectTagFriend}
                className="text-tag-friend-new-post column pointer centerItems ml-2 mr-2"
              >
                <div className="circle-black"></div>
                <div>{Translate("tagFriend", "es")}</div>
              </div>
              <ModalTagFriend
                isProfessionalUser={isProfessionalUser}
                friendsTag={friendsTag}
                setFriendsTag={setFriendsTag}
                displayModal={isShowTagFriend}
                closeModal={selectTagFriend}
              />
              <Button
                onClick={(e) =>
                  (description != "" || Object.values(dataFiles).length > 0) &&
                  onFileUpload(e)
                }
                text={isEditPost ? Translate("edit") : Translate("publish", "es")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // connect ejectua map enviandole el estado general
  return {
    LoadingNewPost: state.fileUpload.filesLoading,
    isLoadingNewPost: state.home.isLoadingNewPost || state.userInfo.loadingNewZonePost,
    LoadingState: state.fileUpload.fileLoadingState,
  };
};

export default connect(mapStateToProps, { fileUpload, createPost, createZonePost, editPost })(
  ModalNewPost
);
